/**
 * Menu module
 * Allows toggling the child navigation component
 * @module
 */
import toArray from 'arrayify';
import BEM from 'bem.js';


const BLOCK_TOOLTIP = 'tooltip';

const ELEMENT_BODY = 'body';

const ELEMENT_ICON = 'icon';

const MODIFIER_OPEN = 'open';

const TOOLTIPS = BEM.getBEMNodes(BLOCK_TOOLTIP);


/**
 * Tooltip class
 * Allows toggling the tooltip body
 * @class
 */
class Tooltip {
    /**
     * Constructor method
     * Gets called when class get instantiated
     */
    constructor() {
        this.setUpToggle();
    }

    /**
     * Calls this.setUpToggleTooltip() for each tooltip in TOOLTIPS
     */
    setUpToggle() {
        toArray(TOOLTIPS).forEach(this.setUpToggleTooltip.bind(this));
    }

    /**
     * Binds various events to this.toggleTooltip()
     * We can't use CSS :hover reliably because it doesn't work well on touch devices
     */
    setUpToggleTooltip(tooltip) {
        tooltip.addEventListener('mouseenter', this.toggleTooltip.bind(this, tooltip));
        tooltip.addEventListener('mouseleave', this.toggleTooltip.bind(this, tooltip));
        tooltip.addEventListener('touchend', this.toggleTooltip.bind(this, tooltip));

        this.trimBody(tooltip);
    }

    /**
     * Toggles MODIFIER_OPEN on tooltip, effectivly hiding/showing it
     * Calls this.updateIcon()
     * @param {HTMLElement} tooltip
     * @param {Event} e
     */
    toggleTooltip(tooltip, e) {
        e.preventDefault();
        BEM.toggleModifier(tooltip, MODIFIER_OPEN);

        this.updateIcon(tooltip);
    }

    /**
     * Set the icon to the correct state
     * @param {HTMLElement} tooltip
     */
    updateIcon(tooltip) {
        let icon = BEM.getChildBEMNode(tooltip, BLOCK_TOOLTIP, ELEMENT_ICON);
        let use = icon.querySelector('use');
        let href = BEM.hasModifier(tooltip, MODIFIER_OPEN) ? '#icon--alert-bold' : '#icon--alert';
        use.setAttribute('xlink:href', href);
    }

    /**
     * Trims the innerText of the body element
     * @param {HTMLElement} tooltip
     */
    trimBody(tooltip) {
        let body = BEM.getChildBEMNode(tooltip, BLOCK_TOOLTIP, ELEMENT_BODY);
        body.innerHTML = body.innerHTML.trim();
    }
}


new Tooltip();  // Initiate this module



// WEBPACK FOOTER //
// ./src/my_artis/js/components/tooltip.js